import React, {Component, Fragment} from 'react'
import {strVal} from '../../../modules/Utils'
import InfoText from '../../../elements/InfoText'
import {Icon} from 'antd'
import {get} from 'lodash'

class ContactDetailsDisplay extends Component {
  render() {
    const {member} = this.props
    return (
      <Fragment>
        {!get(member, 'phone.label') &&
          !get(member, 'mobile.label') &&
          !get(member, 'email.label') && (
            <h3>
              <InfoText text={'No Default Contact Details are available.'} />
            </h3>
          )}
        {get(member, 'phone.label') && (
          <p className={'icon-text'}>
            <Icon
              type="phone"
              style={{
                marginRight: '5px',
                fontSize: 16,
                color: '#08c',
              }}
            />
            {strVal(member, 'phone.label')}
          </p>
        )}
        {get(member, 'mobile.label') && (
          <p className={'icon-text'}>
            <Icon
              type="mobile"
              style={{
                marginRight: '5px',
                fontSize: 16,
                color: '#08c',
              }}
            />
            {strVal(member, 'mobile.label')}
          </p>
        )}
        {get(member, 'email.label') && (
          <p className={'icon-text'}>
            <Icon
              type="mail"
              style={{
                fontSize: 16,
                marginRight: '5px',
                color: '#08c',
              }}
            />
            {strVal(member, 'email.label')}
          </p>
        )}
      </Fragment>
    )
  }
}

ContactDetailsDisplay.propTypes = {}
ContactDetailsDisplay.defaultProps = {fontSize: 16}

export default ContactDetailsDisplay
